var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 11.6912C11.4358 11.6912 12.5999 10.5272 12.5999 9.09121C12.5999 7.65527 11.4358 6.49121 9.9999 6.49121C8.56396 6.49121 7.3999 7.65527 7.3999 9.09121C7.3999 10.5272 8.56396 11.6912 9.9999 11.6912Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01675 7.57533C4.65842 0.358661 15.3501 0.366994 16.9834 7.58366C17.9417 11.817 15.3084 15.4003 13.0001 17.617C11.3251 19.2337 8.67508 19.2337 6.99175 17.617C4.69175 15.4003 2.05842 11.8087 3.01675 7.57533Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDetail);
export default __webpack_public_path__ + "static/media/location-detail.baf30ec528727db51719e8abb27e16d3.svg";
export { ForwardRef as ReactComponent };